module.exports = __webpack_public_path__ + "imgs/ColorOfChange.74fdee5eff78a00785f744bbbeabddee.png";